/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnDestroy } from "@angular/core";
import { Location } from "@angular/common";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";

import { NbAuthService } from "@nebular/auth/services/auth.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { API, THEME, USA_BANNER_LOGIN } from "../app.config";

@Component({
    selector: "nb-auth",
    styleUrls: ["./auth.component.scss"],
    template: `
        <nb-layout>
            <nb-layout-column
                [class.arkbeds-padding]="ARKBEDS_FUNDO"
                [class.banner-login-column]="MOSTRA_BANNER_COLUMN"
                [class.layout-padrao-fundo]="LAYOUT_PADRAO"
            >
                <div
                    *ngIf="MOSTRA_BANNER_COLUMN"
                    class="banner-login-fundo"
                    [style.background-image]="bannerLoginStyle"
                ></div>
                <a href="https://whitelabel.geniusws.com.br/" target="_blank" class="link-imagem"></a>
                <nb-card
                    [class.banner-login-card]="MOSTRA_BANNER_CARD"
                    [class.transparent-fundo]="FRT_FUNDO || FRT_PY_FUNDO || LAYOUT_PADRAO || usaBannerLogin"
                    [style.--banner-login-url]="MOSTRA_BANNER_CARD ? ('url(' + bannerLoginUrl + ')') : null"
                >
                    <nb-card-header
                        [class.border]="ARKBEDS_FUNDO"
                        [class.sem-aparecer]="FRT_FUNDO || ARKBEDS_FUNDO || FRT_PY_FUNDO || LAYOUT_PADRAO || usaBannerLogin"
                    >
                        <nav class="navigation">
                            <a href="#" (click)="back()" class="link" aria-label="Back">
                                <i class="icon nb-arrow-thin-left"></i>
                            </a>
                        </nav>
                    </nb-card-header>
                    <nb-card-body
                        class="row m-0 col-md-12 justify-content-center align-items-sm-center"
                        [class.arkbeds-padding]="ARKBEDS_FUNDO"
                    >
                        <router-outlet></router-outlet>
                    </nb-card-body>
                </nb-card>
            </nb-layout-column>
        </nb-layout>
        <!-- <nb-layout>
       <nb-layout-column [class.arkbeds-padding]="ARKBEDS_FUNDO" [class.frt-fundo]="FRT_FUNDO" [class.frt-py-fundo]="FRT_PY_FUNDO">
        <nb-card   [class.arkbeds-banner]="ARKBEDS_FUNDO"  [class.transparent-fundo]="FRT_FUNDO || FRT_PY_FUNDO">
          <nb-card-header [class.border]="ARKBEDS_FUNDO" [class.sem-aparecer]="FRT_FUNDO || ARKBEDS_FUNDO || FRT_PY_FUNDO">
            <nav class="navigation">
              <a href="#" (click)="back()" class="link" aria-label="Back">
                <i class="icon nb-arrow-thin-left"></i>
              </a>
            </nav>
          </nb-card-header>
          <nb-card-body class="row m-0 col-md-12 justify-content-center align-items-sm-center"[class.arkbeds-padding]="ARKBEDS_FUNDO">
            <router-outlet></router-outlet>
          </nb-card-body>
        </nb-card>
       </nb-layout-column>
     </nb-layout> -->
    `,
})
export class NgxAuthComponent implements OnDestroy {
    private destroy$ = new Subject<void>();

    subscription: any;

    ARKBEDS_FUNDO = THEME === "ARKBEDS";
    FRT_FUNDO = THEME === "FRT";
    FRT_PY_FUNDO = THEME === "FRT-PY";
    LAYOUT_PADRAO =
        THEME !== "ARKBEDS" &&
        THEME !== "FRT" &&
        THEME !== "FRT-PY" &&
        !THEME.includes("FRT") &&
        !USA_BANNER_LOGIN;

    /** Banner de login: URL única por ambiente (API + caminho fixo). */
    bannerLoginUrl = API + "/uploads/imagens/banner-login.png";
    bannerLoginMobileUrl = API + "/uploads/imagens/banner-login-mobile.png";
    /** Estilo sanitizado para permitir URL externa no background-image (Angular bloqueia por padrão). */
    bannerLoginStyle: SafeStyle;

    /** Banner no fundo da coluna (ex.: FRT, FRT-PY ou USA_BANNER_LOGIN). */
    MOSTRA_BANNER_COLUMN = this.FRT_FUNDO || this.FRT_PY_FUNDO || USA_BANNER_LOGIN;
    /** Banner no card (ex.: ARKBEDS). */
    MOSTRA_BANNER_CARD = this.ARKBEDS_FUNDO;

    /** Expõe USA_BANNER_LOGIN para o template. */
    usaBannerLogin = USA_BANNER_LOGIN;

    authenticated: boolean = false;
    token: string = "";

    // showcase of how to use the onAuthenticationChange method
    constructor(
        protected auth: NbAuthService,
        protected location: Location,
        private sanitizer: DomSanitizer
    ) {
        this.bannerLoginStyle = this.sanitizer.bypassSecurityTrustStyle(
            "url(" + this.bannerLoginUrl + ")"
        );
        this.subscription = auth
            .onAuthenticationChange()
            .pipe(takeUntil(this.destroy$))
            .subscribe((authenticated: boolean) => {
                this.authenticated = authenticated;
            });
    }

    back() {
        this.location.back();
        return false;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
